// The viewer's stored AI reasons, keyed by session unique_id.
//
// Blocks that render a session catalog — the Featured Sessions carousel and the
// Related Sessions rail — fetch their lists during SSR. That fetch carries no
// user session, so /api/v1/sessions attaches no reasons to it, and the client
// reuses the SSR payload rather than asking again. Those pages are also
// worker-cached by URL, so per-viewer text must never be in that render in the
// first place.
//
// So the list stays impersonal and cacheable, and this overlays the personal
// part in the browser. Fetched once per page load and shared via useState, so
// several blocks on one page make a single request.
export const useScheduleReasons = () => {
    const reasons = useState('schedule-reasons', () => ({}))
    const requested = useState('schedule-reasons-requested', () => false)

    const load = async () => {
        // Client-only on purpose: on the server there is nothing to personalise
        // with, and a personalised SSR render would poison the page cache.
        if (!import.meta.client || requested.value) return reasons.value
        requested.value = true
        try {
            const res = await $fetch('/api/v1/schedule/reasons')
            reasons.value = res?.reasons || {}
        } catch {
            // Decoration only — a card without its reason is the pre-existing look.
            reasons.value = {}
        }
        return reasons.value
    }

    const reasonFor = (uniqueId) => (uniqueId ? reasons.value?.[uniqueId] || '' : '')

    return { reasons, load, reasonFor }
}
